import UploadMetadataForSave from '@/VueComponents/Uploads/models/uploadMetadataForSave';

export default class SaveUploadMetadataRequest {
  constructor(
    readonly parentId: string,
    readonly uploadMetadataDtos: UploadMetadataForSave[]
  ) { }
}